export const EMPTY = 'empty'
export const SUCCESS = 'success'
export const FAILED = 'failed'
